import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { settings } from './setup';

/**
 * Gets the ECAPPS for a specific org
 * @param {object} params - an object of params
 * @param {string} params.appType - Required to get the details of app based on Experience Cloud or Document Cloud
 * @param {string} params.id - ID required to get the details of the app
 */
export default async (params = {}, signal = null) => {
  const requiredParams = ['id', 'appType'];
  const paramsRules = { id: { allowedTypes: ['string'] }, appType: { allowedTypes: ['string'] } };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }

  const headers = new Headers({
    'x-api-key': settings.apiKey,
  });

  if (params.authToken) {
    headers.append('Authorization', params.authToken);
  }

  const response = await fetch(`${settings.endpoint}/v2/apps/${params.id}?type=${params.appType.toUpperCase()}`, {
    signal,
    headers,
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content;
  }
};
